// extracted by mini-css-extract-plugin
export default {"selectOption":"MonitoringList_selectOption__svlNW","titleCard":"MonitoringList_titleCard__4Ch3j"};